import React from "react";
import {loadComponent} from "../../utils/components";
import PropTypes from "prop-types";
import Icon from "./Icon";
import PropsProxy from "../layout/PropsProxy";
import {operation} from "../../utils/other";
import ContentLoader from "../layout/ContentLoader";

export const stateProp = (stateConst) => {
    const stateType = {};
    Object.keys(stateConst).forEach((key) => {
        stateType[key] = (state, operator) => operation(state, stateConst[key], operator)
    });
    return {stateConst, stateType};
}

export default class StateMachine extends React.Component {

    static propTypes = {
        stateOption: PropTypes.string,
    }

    state = {
        isLoading: true,
        options: []
    }

    constructor(props) {
        super(props);
        this.loadOptions();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.stateOption !== prevProps.stateOption) {
            this.loadOptions();
        }
    }

    loadOptions = () => {
        this.setState({isLoading: true});
        this.loadOptionsRequest && this.loadOptionsRequest.abort();
        this.loadOptionsRequest = loadComponent("componentlist", {
            component: "option",
            filter: [{field: "optionname", value: this.props.stateOption}],
            itemsperpage: 0
        });
        this.loadOptionsRequest.then((response) => {
            this.setState({
                isLoading: false,
                options: response.items
            });
        });
    }


    render() {
        if (!this.props.stateOption) {
            return <Icon lib="fa" name="exclamation-triangle" />;
        }
        if (this.state.isLoading) {
            return <ContentLoader />;
        }
        const props = {...this.props, ...stateProp(this.state.options.reduce((all, current) => {
            return {
                ...all,
                [current.token]: !isNaN(current.optionid) ? parseInt(current.optionid) : current.optionid,
            }
        }, {}))};
        return (
            <PropsProxy {...props}>
                {this.props.children}
            </PropsProxy>
        );
    }
}